import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-merchant-select",
  "use": "icon-icon-merchant-select-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-merchant-select\"><path d=\"M9.411,6.714a2.7,2.7,0,0,1-2.7,2.7H4.591a2.7,2.7,0,0,1-2.7-2.7V4.591a2.7,2.7,0,0,1,2.7-2.7H6.714a2.7,2.7,0,0,1,2.7,2.7Zm0,8.483a2.7,2.7,0,0,1-2.7,2.7H4.591a2.7,2.7,0,0,1-2.7-2.7V13.074a2.7,2.7,0,0,1,2.7-2.7H6.714a2.7,2.7,0,0,1,2.7,2.7Zm8.483-8.483a2.7,2.7,0,0,1-2.7,2.7H13.074a2.7,2.7,0,0,1-2.7-2.7V4.591a2.7,2.7,0,0,1,2.7-2.7H15.2a2.7,2.7,0,0,1,2.7,2.7Zm-3.774,3.6a3.774,3.774,0,1,0,3.774,3.774A3.774,3.774,0,0,0,14.12,10.311Zm0,5.985a2.211,2.211,0,1,1,2.211-2.211A2.211,2.211,0,0,1,14.12,16.3Z\" transform=\"translate(-1.894 -1.894)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-merchant-select.svg
// module id = hKbf
// module chunks = 115